export default __webpack_public_path__ + "static/media/mark-sheet-template-3.2b2bed15.png";